<template>
  <div style="display: flex; flex-direction: column">
    <div style="display: flex; justify-content: space-between">
      <cargo-input v-model="job.notifyCode" style="width:115px;margin-right: 5px;flex-grow: 1;" :placeholder="disabled ? '' : $t('SeaExport.NotifyId')" :auto-uppercase="autoUppercase" :disabled="disabled" @change="onChange('notifyCode')" />
      <cargo-company-select
        :disabled="disabled"
        :method-params="{notify:true,active:true}"
        :default-value="job.notifyId||''"
        style="display: inline-block;width:145px;flex-grow: 1;"
        @change="notifyChange"
      />
    </div>
    <cargo-input
      v-for="i in 7"
      :key="i"
      v-model="job['notifyLine'+i]"
      :use-read-only="true"
      :disabled="disabled"
      :auto-uppercase="autoUppercase"
      style="margin-top: 5px"
      @change="onChange('notifyLine'+i)"
    />
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'AeBasicNotify',
  components: { cargoInput, cargoCompanySelect },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    autoUppercase: { type: Boolean, default: false }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    },
    async notifyChange(data) {
      const form = this.job
      form.notifyId = data.value
      if (form.notifyId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.notifyLine1 = manifestAddress.addressLine1
          form.notifyLine2 = manifestAddress.addressLine2
          form.notifyLine3 = manifestAddress.addressLine3
          form.notifyLine4 = manifestAddress.addressLine4
          form.notifyLine5 = manifestAddress.addressLine5
          form.notifyLine6 = manifestAddress.addressLine6
          form.shipperLine7 = manifestAddress.addressLine7
        } else {
          form.notifyLine1 = ''
          form.notifyLine2 = ''
          form.notifyLine3 = ''
          form.notifyLine4 = ''
          form.notifyLine5 = ''
          form.notifyLine6 = ''
          form.notifyLine7 = ''
        }
      }
      const items = []
      items.push({ key: 'notifyId', value: form.notifyId })
      for (let i = 1; i <= 7; i++) {
        items.push({ key: `notifyLine${i}`, value: form[`notifyLine${i}`] })
      }
      this.$emit('childrenChange', items)
    }
  }
}
</script>
